import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { createTheme } from '@material-ui/core/styles';
import { withStyles, Divider, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export function pxToRem(value) {
    return `${value / 16}rem`;
}

export const breakpoints = createBreakpoints({});

// Page global style
export const pageStyle = () => ({
    root: {
        display: 'flex',
        backgroundColor: '#f0f2f5',
    },
})

// Mobile view global style
export const mobileTheme = createTheme({
    overrides: {
        MuiTypography: {
            h5: {
                fontSize: pxToRem(18),
            },
            body1: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            },
        },
        MuiFormLabel: {
            root: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            },
        },
        MuiButtonBase: {
            root: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            },
        },
        MuiButton: {
            label: {
                fontSize: pxToRem(11),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(13)
                }
            }
        },
        MuiOutlinedInput: {
            input: {
                padding: pxToRem(15) + ' ' + pxToRem(15),
                [breakpoints.up("md")]: {
                    padding: pxToRem(21) + ' ' + pxToRem(21),
                }
            }
        },
        MuiSelect: {
            selectMenu: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            }
        },
        MuiInputBase: {
            input: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                },
            }
        }
    }
});

// MUI-Datatables global style
export const tableTheme = createTheme({
    overrides: {
        MuiInputLabel: {
            formControl: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            },
        },
    }
});

export const tableStyle = theme => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        minHeight: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    muiDataTableIcon: {
        color: '#000',
        fontSize: '1.6em',
        cursor: 'pointer',
        [breakpoints.up("md")]: {
            fontSize: '1.8em',
        }
    },
    customToolbarSelect: {
        marginRight: theme.spacing(3),
        display: 'inline-flex'
    },
    customToolbarSelectText: {
        marginLeft: theme.spacing(1),
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    afterSubmitPage: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 350,
        textAlign: 'center'
    },
    closeButton: {
        position: 'absolute',
        right: '0',
        top: '0',
    }
});

export const getMuiTheme = () => createTheme({
    overrides: {
        MUIDataTableBody: {
            emptyTitle: {
                display: 'none',
                [breakpoints.up("md")]: {
                    display: 'block'
                },
            }
        },
        MUIDataTableBodyCell: {
            stackedCommon: {
                '@media (max-width:959.95px)': {
                    fontSize: '0.8em'
                },
            },
            responsiveStackedSmallParent: {
                '@media (max-width:959.95px)': {
                    border: 'black',
                    height: '3.0rem'
                },
            },
            stackedParent: {
                '@media (max-width:959.95px)': {
                    display: 'inline-flex',
                },
            }
        },
        MUIDataTableToolbar: {
            root: {
                backgroundColor: '#232F3E',
                color: '#FFF',
                minHeight: '3.0em',
                [breakpoints.up("md")]: {
                    minHeight: '4.0rem',
                },
                '@media (max-width:599.95px)': {
                    display: 'inline-flex !important',
                    width: '100%',
                },
            },
            titleText: {
                fontSize: '1.2em',
                '@media (max-width:599.95px)': {
                    textAlign: 'left !important',
                    fontSize: '1.2em !important',
                },
            },
            icon: {
                color: '#FFF',
                '&:hover': {
                    color: '#FFF',
                },
                height: 36,
            },
            iconActive: {
                color: '#FFF',
                height: 36,
            },
            actions: {
                display: 'flex',
                flex: 'initial',
                '& > span, & > button': {
                    order: 99,
                },
                '& > span:last-child, & > button:last-child': {
                    order: 1,
                },
                '& > span:nth-child(4), & > button:nth-child(4)': {
                    order: 2,
                },
                '@media (max-width:599.95px)': {
                    textAlign: 'right !important',
                    fontSize: '1.2em !important',
                },
            },
            filterPaper: {
                [breakpoints.down("sm")]: {
                    position: 'sticky',
                    maxWidth: '100%',
                }
            }
        },
        MUIDataTableToolbarSelect: {
            root: {
                backgroundColor: '#232F3E',
                color: '#FFF',
            },
        },
        MUIDataTableSearch: {
            searchIcon: {
                color: '#FFF',
            },
        },
        MUIDataTableHeadCell: {
            root: {
                fontWeight: 600
            },
            data: {
                fontWeight: 600
            },
            sortActive: {
                fontWeight: 600
            }
        },
        MUIDataTablePagination: {
            tableCellContainer: {
                padding: '0px 0px 0px 0px',
                [breakpoints.up("md")]: {
                    padding: '0px 24px 0px 24px',
                }
            }
        },
        MUIDataTableSelectCell: {
            fixedLeft: {
                width: '40px',
                padding: '0px 0px 0px 0px',
                [breakpoints.up("md")]: {
                    width: '48px',
                    padding: '0px 0px 0px 4px',
                }
            },
        },
        MUIDataTableFilter: {
            gridListTile: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            },
            checkboxListTitle: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            },
            checkboxFormControlLabel: {
                fontSize: pxToRem(14),
                [breakpoints.up("md")]: {
                    fontSize: pxToRem(16)
                }
            }
        }
    }
})

// Dialog global style
export const globalDialogStyle = (theme) => ({
    root: {
        display: 'flex-direction',
        flexWrap: 'wrap',
    },
    dialogContent: {
        paddingBottom: theme.spacing(1),
        fontSize: 14,
        height: 40,
        width: 350
    },
})

export const adminDialogStyle = (theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    showButtonDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    showButton: {
        marginBottom: theme.spacing(1),
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        },
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%'
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
})

export const messageBoxDialogStyle = (theme) => ({
    title: {
        fontSize: 20,
    },
    subtitle: {
        marginBottom: theme.spacing(1),
    },
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    afterSubmitPage: {
        textAlign: 'center'
    },
    okButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    yesButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    noButton: {
        marginLeft: 10,
        width: 70
    },
    formControl: {
        paddingBottom: theme.spacing(2),
    },
})

export const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        [breakpoints.up("md")]: {
            width: 350
        },
    },
}))(MuiDialogContent);

const dialogStyles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
        backgroundColor: '#232F3E',
        color: '#FFF'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(0),
        color: theme.palette.grey[500],
    },
});

export const DialogTitle = withStyles(dialogStyles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose && (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            )}
        </MuiDialogTitle>
    );
});

// Review global style
export const reviewStyle = (theme) => ({
    title: {
        fontSize: 20,
    },
    subtitle: {
        marginBottom: theme.spacing(1),
    },
    colorSubtitle: {
        color: '#3F51B5',
        marginBottom: theme.spacing(1),
    },
    successIcon: {
        fontSize: 'large',
    },
    buttonDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    submitButton: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow:'scroll',
    },
    afterSubmitPage: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 350,
        textAlign: 'center'
    },
})


export const StyledDivider = withStyles({
})(Divider);
